import { observable } from 'mobx';
import Helpers from '../../helpers/Helpers';
import { ExerciseModel } from '../../interfaces/models/CardModel';
import { AnswersAdapter, AnswerModel, ExerciseType } from './AnswersAdapter';

export class ExerciseAdapter implements AnswersAdapter {

    totalPlaceholders = 1;
    contentParts;
    type = ExerciseType.exercise;

    @observable answers: AnswerModel[];

    constructor(
        public field: ExerciseModel
    ) {
        this.answers = Helpers.shuffle([
            ...this.field.false_answers.map((answer, index) => ({ answer, index })),
            {
                answer: this.field.solution,
                index: this.field.false_answers.length,
                isCorrect: true
            }
        ]);

        this.contentParts = this.field.content
            .split(/\[solution]/)
            .filter(value => value.length);
    }

    verifyAnswer(index, currentPlaceholderIndex) {
        return this.answers.filter(answer => answer.index === index)[0].isCorrect;
    }

}
